import { render } from "./SimpleHeader.vue?vue&type=template&id=2adef164&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"

import "./SimpleHeader.vue?vue&type=style&index=0&id=2adef164&lang=less&scoped=true"

import exportComponent from "E:\\case\\要点传达商城\\6-5\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adef164"]])

export default __exports__